<template>
  <div class="tagEditorContainer">
    <p class="howTo">
      <small>
        <v-icon>mdi-help-circle-outline</v-icon>
        {{ t("howToTags") }}
      </small>
    </p>

    <v-textarea v-model="options" :disabled="loading" rbt-target="tagsTextarea" hide-details />

    <div class="boxFooter">
      <div class="checks">
        <v-checkbox
          v-model="tempTagDetails.requiredOnNewSpaces"
          :disabled="loading"
          :label="t('checkbox.mandatory')"
          :rbt-target="toCamel(`required ${parent}`)"
          hide-details
        />
        <v-checkbox
          v-model="tempTagDetails.allowNewValues"
          :disabled="loading"
          :label="t('checkbox.canCreate')"
          :rbt-target="toCamel(`allowNew ${parent}`)"
          hide-details
        />
      </div>

      <div class="controller">
        <v-btn @click="$emit('remove')" :rbt-target="toCamel(`removeButton ${parent}`)" :disabled="loading">
          {{ t("editorButton.remove") }}
        </v-btn>

        <v-btn
          @click="$emit('save', tempTagDetails)"
          :disabled="loading"
          :rbt-target="toCamel(`editorButton ${parent}`)"
          color="primary"
        >
          {{ t("editorButton.save") }}
        </v-btn>
      </div>
    </div>

    <span class="--scroll-anchor" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, PropType } from "@vue/composition-api"
import { TagOptions } from "@/types/organization"
import { createTranslationModule } from "@/plugins/i18n"
import Utils from "@/utils/utils"

export default defineComponent({
  name: "TagEditor",
  props: {
    details: {
      type: Object as PropType<TagOptions>,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    parent: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const t = createTranslationModule("OrganizationPageV2.spaceTags")
    const tempTagDetails = ref({ ...props.details })

    const options = computed({
      get() {
        return tempTagDetails.value.options.join(", ")
      },
      set(value: string) {
        const rawOptions = value.trim().split(",")

        tempTagDetails.value.options = rawOptions
          .map(rawOption => rawOption.trim())
          .filter(rawOption => rawOption.trim())
      }
    })

    const toCamel = (name: string) => {
      return Utils.toCamel(name)
    }

    return {
      t,
      toCamel,
      options,
      tempTagDetails
    }
  }
})
</script>
